import React from 'react';
import SpriteAnimatedLogo from '../ui/SpriteAnimatedLogo.js';
import { DEFAULT_ANIM_FRAME_RATE, CONTACT_EMAIL } from '../config/const.js';
import { SPRITES } from '../ui/SpriteAnimatedLogo.js';
import { createMailtoLink } from '../utils/email.js';


const Enterprise = () => {
  const demoEmailLink = createMailtoLink(CONTACT_EMAIL, '', '');

  return (
    <section className="enterprise">
      <div className="enterprise-container">
        <div className="enterprise-main-layout">
          <div className="enterprise-left">
            <div className="section-label">
              <span>For enterprise</span>
            </div>
            <h2 className="enterprise-title">Enterprise-grade AI solutions for your business needs</h2>
            <p className="enterprise-subtitle">
              Powerful tools and dedicated support to scale your AI applications with confidence
            </p>
          </div>

          <div className="enterprise-right">
            <div className="enterprise-features-grid">
              <div className="enterprise-feature-card card-blue">
                <h3>Commercial License</h3>
                <p>Full proprietary features, commercial usage rights, and white-labeling options for your enterprise needs</p>
              </div>

              <div className="enterprise-feature-card card-green">
                <h3>Custom Development</h3>
                <p>SSO/RBAC integration and dedicated algorithm team for scenario-specific optimization</p>
              </div>

              <div className="enterprise-feature-card card-purple">
                <h3>Intelligence & Analytics</h3>
                <p>User behavior analysis, real-time monitoring, and automated agent optimization tools</p>
              </div>

              <div className="enterprise-feature-card card-orange">
                <h3>Premium Support</h3>
                <p>24/7 dedicated support team, custom SLAs, and professional implementation services</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="enterprise-cta-section">
        <div style={{ position: 'relative' }}>
          <div className="enterprise-cta-card">
            <div className="cta-content">
              <h3>Ready to scale your AI applications?</h3>
              <p>Contact our enterprise team (contact@nevamind.ai) to discuss your specific requirements and get a custom solution.</p>
              <a href={demoEmailLink} className="btn btn-primary btn-md" target="_blank" rel="noopener noreferrer">
                Contact sales →
              </a>
            </div>
          </div>
          <div className="enterprise-anim1">
            <SpriteAnimatedLogo
              width={80}
              height={80}
              frameRate={DEFAULT_ANIM_FRAME_RATE}
              autoPlay={true}
              filename={SPRITES.ANIM_TAIL_WAVE} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Enterprise;